import { ReactNode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useNotification } from './shared/utils/notification/useNotification';
import { mandantClient } from './api/mandant-api';

interface AppContainerProps {
  readonly children: ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: Infinity,
      queryFn: ({ queryKey }) => mandantClient.get(queryKey.at(0))
    }
  }
});

export function AppContainer({ children }: AppContainerProps) {
  const { notifyUserFromRequest } = useNotification();
  queryClient.setDefaultOptions({
    queries: {
      queryFn: ({ queryKey }) =>
        notifyUserFromRequest(() =>
          mandantClient.get(queryKey.at(0) as string)
        ),
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity
    }
  });

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
